import { Folder, FolderContent } from '@/api/generatedApi';
import { isAsset } from './assets';

// eslint-disable-next-line unicorn/no-null -- null is the canonical representation of root folder
export const ROOT_FOLDER_ID = null;

export type RootFolderId = typeof ROOT_FOLDER_ID;
export type FolderId = string | RootFolderId | undefined;

export const isRootFolderId = (folderId: FolderId): folderId is RootFolderId => folderId === ROOT_FOLDER_ID;

export type FolderContentFolder = Extract<FolderContent, { contentType: 'folder' }>;

export const isFolder = (asset: unknown): asset is Folder => {
  if (!asset || typeof asset !== 'object') return false;
  return (asset as FolderContent).contentType === 'folder';
};

export const getFoldersFromFolderContents = (contents: FolderContent[]) => {
  return contents.filter(content => isFolder(content)) as Folder[];
};

export const getContentParentFolderId = (content: FolderContent): string | undefined => {
  if (isFolder(content)) {
    return content.parentFolderId ?? undefined;
  }
  if (isAsset(content)) {
    return content.folderId ?? undefined;
  }
  return undefined;
};
